import { useState, useEffect } from "react";
import { message, Modal } from "antd";

import Layout from '../Layout/Layout'
import Header from "../Components/Header";
import Achievement from "../Components/Achievement";
import CardSection from "../Components/CardSection";
import { url, header } from "../Constent/Constant";

const MovingPlanner = () => {
    const [PlannerData, setPlannerData] = useState('')
    const [HeadingUpdate, setHeadingUpdate] = useState('')
    const [TextModalVisible, setTextModalVisible] = useState(false);
  const [UpdateId, setUpdateId] = useState('')

    useEffect(() => {
        UpdateData()
    }, [])

    const UpdateData = () => {
        fetch(`${url}/page/viewpagedata`, {
            method: 'POST',
            body: JSON.stringify({
                name: "Moving Planner"
            }),
            headers: header
        })
            .then(res => res.json())
            .then(data => {
                console.log('AboutUs Data ==>', data)
                setPlannerData(data.doc)
            })
    }

    const UpdateText = (DataObject) => {
        console.log(DataObject)
        if (DataObject !== '') {
            fetch(`${url}/page/updatedata`, {
                method: 'POST',
                body: JSON.stringify({
                    id: DataObject.id,
                    content: DataObject.text
                }),
                headers: header
            })
                .then(res => res.json())
                .then(data => {
                    console.log(data)
                    if (data.message === 'Success') {
                        UpdateData()
                    }
                })
        }
    }

    const UpdateImage = (DataObject) => {
        const Imagedata = new FormData();
        Imagedata.append('image', DataObject.image)
        Imagedata.append('id', DataObject.id)

        fetch(`${url}/page/updateimage`, {
            method: 'POST',
            body: Imagedata
        })
            .then(res => res.json())
            .then(data => {
                console.log(data)
                if (data.message === 'Success') {
                    UpdateData()
                }
            })
    }

    const handleCancel = () => {
        setTextModalVisible(false);
      };
    
      const ShowTextModal = (id) => {
        setTextModalVisible(true);
        setUpdateId(id)
      };

    const TextHandle = () => {
        if (HeadingUpdate === '') {
          message.error('Fill the Field')
        } else {
          UpdateText({
            text: HeadingUpdate,
            id: UpdateId
          })
          setTextModalVisible(false);
          setHeadingUpdate('')
        }
      };

    const OnEnterPress = (event) => {
        const a = HeadingUpdate
        console.log(a)
        if(event.key === 'Enter'){
          console.log('Enter Clicked')
          a.concat('\n')
          setHeadingUpdate(a)
        }else{
          console.log(event.key)
        }
      }
    return (

        <Layout>
            {PlannerData &&
                <Header
                    UpdateText={UpdateText}
                    UpdateImage={UpdateImage}
                    GetData={{
                        imgId: PlannerData.section1image1._id,
                        headingId: PlannerData.section1heading1._id
                    }}
                    Image={PlannerData.section1image1.image} />}


            {PlannerData && <Achievement
                UpdateText={UpdateText}
                UpdateImage={UpdateImage}
                CardSection={{
                    image: PlannerData.section2image1.image,
                    imageId: PlannerData.section2image1._id,
                    heading: PlannerData.section2heading1.content,
                    headingId: PlannerData.section2heading1._id,
                    para: PlannerData.section2paragraph1.content,
                    paraId: PlannerData.section2paragraph1._id,
                }} />
            }

            {PlannerData && <CardSection
                UpdateText={UpdateText}
                UpdateImage={UpdateImage}
                Heading={PlannerData.section3heading1.content}
                HeadingId={PlannerData.section3heading1._id}
                CardData={{
                    card1: {
                        img: PlannerData.section3image1.image,
                        imgId: PlannerData.section3image1._id,
                        heading: PlannerData.section3heading2.content,
                        headingId: PlannerData.section3heading2._id,
                        para: PlannerData.section3paragraph1.content,
                        paraId: PlannerData.section3paragraph1._id,
                    },
                    card2: {
                        img: PlannerData.section3image2.image,
                        imgId: PlannerData.section3image2._id,
                        heading: PlannerData.section3heading3.content,
                        headingId: PlannerData.section3heading3._id,
                        para: PlannerData.section3paragraph2.content,
                        paraId: PlannerData.section3paragraph2._id,
                    },
                    card3: {
                        img: PlannerData.section3image3.image,
                        imgId: PlannerData.section3image3._id,
                        heading: PlannerData.section3heading4.content,
                        headingId: PlannerData.section3heading4._id,
                        para: PlannerData.section3paragraph3.content,
                        paraId: PlannerData.section3paragraph3._id,
                    }
                }} />
            }
            <div className='MovingPlannerDiv'>
                {PlannerData && <CardSection
                UpdateText={UpdateText}
                UpdateImage={UpdateImage}
                    Heading={PlannerData.section4heading1.content}
                    HeadingId={PlannerData.section4heading1._id}
                    CardData={{
                        card1: {
                            img: PlannerData.section4image1.image,
                            imgId: PlannerData.section4image1._id,
                            heading: PlannerData.section4heading2.content,
                            headingId: PlannerData.section4heading2._id,
                            para: PlannerData.section4paragraph1.content,
                            paraId: PlannerData.section4paragraph1._id,
                        },
                        card2: {
                            img: PlannerData.section4image2.image,
                            imgId: PlannerData.section4image2._id,
                            heading: PlannerData.section4heading3.content,
                            headingId: PlannerData.section4heading3._id,
                            para: PlannerData.section4paragraph2.content,
                            paraId: PlannerData.section4paragraph2._id,
                        },
                        card3: {
                            img: PlannerData.section4image3.image,
                            imgId: PlannerData.section4image3._id,
                            heading: PlannerData.section4heading4.content,
                            headingId: PlannerData.section4heading4._id,
                            para: PlannerData.section4paragraph3.content,
                            paraId: PlannerData.section4paragraph3._id,
                        }
                    }} />
                }
            </div>
            {
                PlannerData && <p className='MP-para'>
                    {PlannerData.section5paragraph1.content}
                    <i onClick={() => ShowTextModal(PlannerData.section5paragraph1._id)} className="far fa-edit Edit-btn"></i>
                </p>
            }

            {/* Update Text Modal */}
            <Modal width={400} style={{ top: '20%' }} title='Update Text' visible={TextModalVisible} onOk={TextHandle} onCancel={handleCancel} okText="Update" >
                <textarea onKeyPress={(e) => OnEnterPress(e)} value={HeadingUpdate} onChange={e => setHeadingUpdate(e.target.value)} className='Input' placeholder='Update Text...' />
            </Modal>

        </Layout>
    )
}

export default MovingPlanner
